const ReviewStars = ({ stars, color, className, gap = '0.1rem', size = '0.95rem' }) => {
    const c = color || '#e8a317';
    const n = Number(stars);
    if (n == null || Number.isNaN(n) || n <= 0) {
        return null;
    }
    const style = { color: c, gap, fontSize: size };
    if (n > 4.5) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
            </div>
        );
    }
    if (n > 4) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-half" aria-hidden="true" />
            </div>
        );
    }
    if (n > 3.5) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
            </div>
        );
    }
    if (n > 3) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-half" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
            </div>
        );
    }
    if (n > 2.5) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
            </div>
        );
    }
    if (n > 2) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-half" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
            </div>
        );
    }
    if (n > 1.5) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
            </div>
        );
    }
    if (n > 1) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star-half" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
            </div>
        );
    }
    if (n > 0.5) {
        return (
            <div className={`d-flex align-items-center ${className || ''}`} style={style} role="img" aria-label={`${n.toFixed(1)} out of 5 stars`}>
                <i className="bi bi-star-fill" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
                <i className="bi bi-star" aria-hidden="true" />
            </div>
        );
    }
    return null;
};

export default ReviewStars;
